import React from 'react'
import { Badge, Card } from 'reactstrap'
import { UserAvatar } from '../../../../components/Component'

function RecentStores({ recent_stores }) {
    return (
        <Card className="h-100">
            <div className="card-inner">
                <div className="card-title-group mb-2">
                    <div className="card-title">
                        <h6 className="title">Recently Added Stores</h6>
                    </div>
                </div>
                <ul className="nk-top-products">
                    {recent_stores?.map((store, idx) => (
                        <li className="item" key={idx}>
                            <div className="thumb">
                                <UserAvatar className="sm" theme='primary-dim' text={store?.name?.charAt(0)?.toUpperCase()} ></UserAvatar>
                            </div>
                            <div className="info">
                                <div className="title">{store?.name}</div>
                                <div className="price">{store?.phone}</div>
                            </div>
                            <div className="total">
                                <div className="amount"><Badge color='warning'>{store?.store_category?.name}</Badge></div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </Card>
    )
}

export default RecentStores